var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalTemplateForgot',{attrs:{"modal-title":_vm.$t('AccountPage.Modal.PasswordModal.Title'),"modal-description":_vm.$t('AccountPage.Modal.PasswordModal.Description'),"email":_vm.email},on:{"cancel":_vm.cancel,"send":_vm.send}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }